const CM_TO_INCHES = 0.393701;
function toInches(value) {
  // first check if its got a dash in it for number range
  // and then split and convert
  if(value.includes('-')){
    const values = value.split('-');
    return values.map(value => {
      if (!isNaN(Number(value))) return Math.round(Number(value) * CM_TO_INCHES);
    }).join('-');
  }
  
  //if the cell is blank just return it
  if (!value) return value;

  return !isNaN(Number(value)) ? (Math.round(Number(value) * CM_TO_INCHES)) : value;
}
export function _parseMeasurement(measurement, units) {
  const formattedData = measurement.data.rows.reduce((acc, curr, index) => {
    if (index == 0 ) {
      acc.push(curr.cells);
      return acc;
    }

    if (units != "cm") {
      const rows = curr.cells.map((value, idx) => {
        return toInches(value);
      })
      acc.push(rows);
      return acc;
    }
    acc.push(curr.cells);
    return acc;
  }, []);
  return formattedData;
}
